<template>
    <div class="content-wrapper">
        <PageHeader screenName="Ver doses" :linkItems="linkItems" />

        <ConfirmAtivarInativarDoseModal :modalShow="modal.showModal" :typeModal="modal.typeModal"
            @confirmed="changeStateDose" @canceled="cancelarDesativarDose" />

        <TimedAlert variant="danger" :message="alert.errorMessage" :show="alert.show" />

        <main class="card hidden_overflow_tabela">
            <div v-if="canInsert" class="pt-2 px-2">
                <b-button @click="redirectToRegister()" variant="primary-button">
                    <feather-icon icon="PlusIcon" class="mr-50" />
                    <span class="align-middle">Adicionar nova dose</span>
                </b-button>
                <hr>
            </div>
            <FilterDoseList
                :filter="filter"
                :parameters="getParams"
                :paginationTotalLines="paginationData.totalLines"
                :tableItemsLength="table.items.length"
                @filterTable="loadDataDose"
            />
            <div v-if="loadingData" class="d-flex justify-content-center my-3">
                <output class="spinner-border text-custom-blue" aria-live="polite">
                    <span class="visually-hidden">Carregando...</span>
                </output>
            </div>
            <section class="list-dose" v-if="!loadingData">
                <b-table id="tableDose" responsive :stickyColumn="true" :busy.sync="filtering" :fields="table.fields"
                    :items="table.items" @sort-changed="ordenarColuna" no-local-sorting :no-sort-reset="true">
                    <template #cell(nome_tecnico_doenca)="row">
                        <span class="font-weight-bold comprimento_maximo_celulas" v-b-tooltip
                            :title="row.item.descricao > lengthDescricaoMaxima ? row.item.descricao : null">
                            {{ row.item.descricao }}
                        </span>
                    </template>
                    <template #cell(ativo)="row">
                        <TableSwitch :disabled="!canEdit" :checked="row.item.ativo" :description="row.item.descricao"
                            :itemId="row.item.id_dose" @stateModified="openModalConfirm" />
                    </template>
                    <template #cell(actions)="row">
                        <button @click.prevent="redirectToShow(row.item)" id="view-dose"
                            class="icon-button text-custom-blue mr-1" v-b-tooltip.hover.html
                            title="<b>Detalhes da Dose</b>">
                            <feather-icon icon="EyeIcon" size="18" aria-hidden="true" />
                            <span class="visually-hidden">Ver detalhes da dose</span>
                        </button>
                        <span v-if="canEdit"
                            v-b-tooltip.hover.html="!row.item.ativo ? '<b>Essa dose está inativa e não pode ser editada</b>' : '<b>Editar Dose</b>'"
                            class="d-inline-block">
                            <button :disabled="!row.item.ativo" @click.prevent="redirectToEdit(row.item)" id="edit-dose"
                                :class="['icon-button text-custom-blue', { 'icon-disabled': !row.item.ativo }]">
                                <feather-icon icon="EditIcon" size="18" aria-hidden="true" />
                                <span class="visually-hidden">Editar dose</span>
                            </button>
                        </span>
                    </template>
                </b-table>
                <div class="pb-2 px-1">
                    <span v-if="withoutDose" class="ml-1">Nenhuma dose encontrada</span>
                    <b-col sm="12" class="mt-2">
                        <CustomPagination :paginacao="paginationData" @page-cliked="updateCurrentPage" />
                    </b-col>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import { actions, subjects } from "@/libs/acl/rules";
import { BForm, BCol, BRow, BFormGroup, BFormInput, BButton, BTable, VBTooltip } from 'bootstrap-vue'
import vSelect from 'vue-select'
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import TableSwitch from '@/views/components/custom/table-switch/TableSwitch.vue'
import FilterDoseList from '@/views/custom-pages/dose/Components/FilterDoseList.vue'
import ConfirmAtivarInativarDoseModal from '@/views/components/custom/modals/ConfirmAtivarInativarDoseModal.vue'
import TimedAlert from '@/views/components/custom/timed-alert/TimedAlert.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    title: 'Doses',

    components: {
        BForm, BCol, BRow, BFormGroup, BFormInput,
        BButton, BTable, TableSwitch, FilterDoseList,
        vSelect, CustomPagination, PageHeader,
        ConfirmAtivarInativarDoseModal, TimedAlert, VuePerfectScrollbar
    },

    directives: {
        'b-tooltip': VBTooltip
    },

    data() {
        return {
            alert: {
                errorMessage: '',
                show: false
            },
            settings: {
                maxScrollbarLength: 70,
                wheelSpeed: 0.2,
                wheelPropagation: false
            },
            linkItems: [
                {
                    name: 'Doses',
                    active: true
                }
            ],
            filtering: false,
            filter: false,
            loadingData: true,
            withoutDose: false,
            canEdit: false,
            canInsert: false,
            table: {
                fields: [
                    { key: "descricao", label: "DOSE", sortable: true, class: 'mw-400' },
                    { key: "br_dose", label: "CÓDIGO", sortable: true, class: 'mw-300' },
                    { key: "ativo", label: "STATUS", sortable: true, class: 'comprimento_status' },
                    { key: "actions", label: "AÇÕES", sortable: false, class: 'mw-150 text-center col-1' }
                ],
                items: [],
                optionsSize: [10, 25, 50, 100],
                columnOrder: 'br_dose',
                order: 'asc'
            },
            paginationData: {
                currentPage: 0,
                totalLines: 0,
                fromLine: 0,
                toLine: 0,
                defaultSize: 10,
            },
            itemDesativar: null,
            modal: {
                showModal: false,
                typeModal: 'success',
            },
            lengthDescricaoMaxima: 28,
            search: {
                descricao: null,
                br_dose: null,
                ativo: null
            }
        }
    },
    mounted() {
        this.canEdit = this.verifyPermissions(actions.ATUALIZAR)
        this.canInsert = this.verifyPermissions(actions.INSERIR)
    },
    methods: {
        loadDataDose(filterData = null) {
            this.paginationData.defaultSize = filterData ? filterData.defaultSize : 10;

            if (filterData.hasOwnProperty('currentPage')) { this.paginationData.currentPage = filterData.currentPage; }

            this.search = filterData;

            this.filtering = true;

            this.$http.get(this.$api.getDose(), { params: this.getParams }).then(({ data }) => {
                this.table.items = data.data;

                this.withoutDose = false;
                if (data.data.length == 0) {
                    this.withoutDose = true;
                }

                this.loadingData = false;

                this.filtering = false;
                this.startPagination(data)
            })
        },

        startPagination(data) {
            this.paginationData.currentPage = data.current_page;
            this.paginationData.totalLines = data.total;
            this.paginationData.fromLine = data.from;
            this.paginationData.toLine = data.to;
        },

        ordenarColuna(sort) {
            this.table.columnOrder = sort.sortBy;
            this.table.order = sort.sortDesc ? 'desc' : 'asc';

            this.filtering = true;
            this.filter = !this.filter;
        },

        updateCurrentPage(page) {
            this.paginationData.currentPage = page;
            this.filtering = true;
            this.filter = !this.filter;
        },

        redirectToEdit({ id_dose }) {
            this.$router.push(
                {
                    name: 'dose-edit',
                    params: {
                        idDose: id_dose
                    }
                }
            );
        },

        redirectToShow({ id_dose, descricao, br_dose, ativo }) {
            this.$router.push(
                {
                    name: 'dose-show',
                    params: {
                        idDose: id_dose,
                        descricao: descricao,
                        codigo: br_dose,
                        status: ativo
                    }
                }
            );
        },

        openModalConfirm(values) {
            this.modal.typeModal = 'warning';

            if (values.state) {
                this.modal.typeModal = 'success';
            }

            this.$helpers.changeStateActiveTableRow(this.table.items, values, 'id_dose');

            this.itemDesativar = values;
            this.modal.showModal = true;
        },

        changeStateDose() {
            this.$http.patch(this.$api.doseWithParameter(this.itemDesativar.itemId))
                .then(() => {
                    this.modal.showModal = false;
                })
                .catch(({ response: { data } }) => {
                    this.modal.showModal = false;
                    this.$helpers.backStateActiveTableRow(this.table.items, this.itemDesativar, 'id_dose');
                    this.alert.errorMessage = data.errors;
                    this.alert.show = true;
                });
        },

        cancelarDesativarDose() {
            this.$helpers.backStateActiveTableRow(this.table.items, this.itemDesativar, 'id_dose');

            this.modal.showModal = false;
        },

        redirectToRegister() {
            this.$router.push({ name: 'dose-register' });
        },

        verifyPermissions(action) {
            const permission = this.$can(actions[action], subjects.DOSE)

            return [permission].includes(true);
        }
    },
    computed: {
        getParams() {
            return {
                ativo: this.search.ativo,
                descricao: this.search.descricao,
                br_dose: this.search.br_dose,
                tamanho: this.paginationData.defaultSize,
                pagina: this.paginationData.currentPage,
                colunaOrdenar: this.table.columnOrder,
                ordem: this.table.order
            }
        }
    }
}
</script>

<style>
.visually-hidden {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
}

.icon-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.icon-disabled {
    opacity: 0.3;
    pointer-events: none;
}

.label_size_dose {
    font-size: 15px;
}

.comprimento_maximo_celulas {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
}

.comprimento_maximo_tabela_header {
    width: 160px;
}

.comprimento_status {
    width: 100px;
}

.hidden_overflow_tabela {
    overflow: visible !important;
}
</style>
